var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("HeadInfo", { attrs: { title: "综艺" } }),
      _vm._v(" "),
      _c("EpisodeTvshow"),
      _vm._v(" "),
      _c("Relative"),
      _vm._v(" "),
      _c("Actors"),
      _vm._v(" "),
      _c("Like"),
      _vm._v(" "),
      _c("Gotop"),
      _vm._v(" "),
      _c("Rec"),
      _vm._v(" "),
      _c("Ob"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }